import {DiscontinuedProduct} from "../../../../api/Products";
import {ProductLookup} from "./ProductLookup";
import {api} from "../../../../api/API";
import {Alert, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import {grey} from "@mui/material/colors";

export function DiscontinuedReplaceWith(props: {
    id: number;
    value: DiscontinuedProduct[];
    onChange(value: DiscontinuedProduct[]): void;
}) {

    return (
        <div>
            <div>
                Suggested Replacements
            </div>
            <List dense>
                {props.value.map(v => (
                    <ListItem>
                        <ListItemText
                            primary={v.productCode + " (" + v.finish + ")"}
                            secondary={v.manufacturerName}
                        />
                        <ListItemSecondaryAction>
                            <IconButton onClick={() => {
                                const newValues = [...props.value];
                                newValues.splice(newValues.indexOf(v), 1);
                                props.onChange(newValues);
                            }}>
                                <DeleteIcon />
                            </IconButton>
                        </ListItemSecondaryAction>
                    </ListItem>
                ))}
                {props.value.length === 0 && <Alert severity="info">
                    Search for a product to add below
                </Alert>}
            </List>
            <div style={{
                border: "1px solid " + grey["400"],
                borderRadius: "4px",
            }}>
                <ProductLookup
                    placeholder="Search for product"
                    onSelect={async product => {
                        if(props.value.find(s => s.id === product.id)) return;
                        if(product.id === props.id) return;

                        const pr = await api.products.getById(product.id);
                        props.onChange([...props.value, pr]);
                    }}
                />
            </div>
        </div>
    )
}